<template>
<div class="chapter">
<div class="inner_page">
<p class="h2"><a id="page_6"></a>Acknowledgements</p>
<p class="noindent"><span class="dropcap">T</span>he authors would like to thank the following for their contributions, advice, suggestions, permissions and loan of materials, without which this book could not have been compiled: Nick Baines, Peter Bishop, John Boyle, Kay Butler, Chris Cox, Anthony Dawson, Marc Dobson, Bob Essery, Ben Fraser, Alan Garner, John Hewlett, David Mills, <em class="italic">Railway Modeller</em>, Roger Pidgeon, Ruth and Graham Powell, Nick Salzman, Graham Varley, Cor de Jong, Paul Marchese, Ian Wright and David Viewing.</p>
<p class="indent">We also thank our wives Margaret and Jane for their encouragement and forbearance during the writing of the book.</p>
<p class="right">Peter Chatham.<span class="span-text"> Stephen Weston</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_ack.vue?e12c73e4